<script setup lang="ts">
import type { NuxtLinkProps } from '#app'

const props = defineProps<NuxtLinkProps>()
const isInternal = computed(
  () =>
    props.to?.toString().startsWith('/') &&
    !props.to?.toString().startsWith('//')
)
</script>
<template>
  <NuxtLink
    class="font-kyiv text-sm text-left px-20 py-10 no-underline xl:text-base font-medium block w-full text-primary lg:border-transparent lg:hover:border-primary/50 lg:border-b-[6px] lg:flex-initial lg:mr-35 xl:mr-[45px] 2xl:mr-[55px] lg:px-0 lg:pt-[18px] lg:pb-[14px] lg:inline-block lg:w-auto transition"
    :target="!isInternal ? '_blank' : undefined"
    :rel="!isInternal ? 'noopener noreferrer' : undefined"
    :to
  >
    <slot />
  </NuxtLink>
</template>

<style lang="postcss" scoped>
.router-link-exact-active,
.router-link-active {
  @apply lg:border-primary;
}
</style>
